import React, { Component } from "react";
import Swal from "sweetalert2";
import Pagination from "@mui/material/Pagination";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
const tokens = localStorage.getItem("scp-acc-tk") || "";
const profile = localStorage.getItem("scp-profile") ? JSON.parse(localStorage.getItem("scp-profile")) : null;
const required = (<span className="text-danger text-18">*</span>);
const alert = (url, icon, title, detail, confirm, cancel) => {
  if(document.getElementsByClassName("swal2-modal").length < 2){
    return Swal.fire({
      icon: icon || "warning",
      title: icon === "success" ? "สำเร็จ" : title || "แจ้งเตือน",
      text: icon === "success" ? "ทำรายการสำเร็จ" : detail || " ",
      confirmButtonText: confirm || "ตกลง",
      showCancelButton: cancel ? true : false,
      cancelButtonText: cancel || "ยกเลิก",
    }).then((result) => {
      if (result.isConfirmed) {
        if (url && url !== "#") {
          window.location.href = url;
        } else if (url && url === "#") {
          window.location.reload();
        }
        return !!result.isConfirmed;
      } else if (url && url !== "#") {
        window.location.href = url;
      } else if (url && url === "#") {
        window.location.reload();
    }
    });
  }
};
const total = (array, key) => {
  if (!Array.isArray(array)) return 0;
  return key 
    ? array.reduce((sum, item) => Number(sum) + (Number(item[key]) || 0), 0)
    : array.reduce((sum, item) => Number(sum) + (Number(item) || 0), 0);
};
const float = (num, length) => {
  const regexPattern = length 
    ? /^\d*\.?\d{0,100}$/ 
    : /^\d*\.?\d{0,2}$/;
  return !!regexPattern.test(num);
};
const toFixed = (number, size = 2, ceil = false) => {
  if (!number && number !== 0) return "0.00";
  if (number === 0) return "0.00";

  const num = Number(number.toString());
  const precision = size || 2;
  const processedNum = ceil ? Math.ceil(num * Math.pow(10, precision)) / Math.pow(10, precision) : num;

  return processedNum.toFixed(precision).replace(/\d(?=(\d{3})+\.)/g, "$&,");
};
const format_date = (date, format, locale, type_excel) => {
  const array_month = locale?.toLowerCase() === "en" 
    ? ["Jan.", "Feb.", "Mar.", "Apr.", "May.", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."] 
    : ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."];
    
  const array_full_month = locale?.toLowerCase() === "en" 
    ? ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"] 
    : ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"];

  let processedDate = date;
  
  if (type_excel) {
    if (Number(date)) {
      processedDate = new Date(date * 24 * 60 * 60 * 1000 + Date.parse("1899-12-30"));
    } else if (typeof date === "string") {
      const separator = date.includes("/") ? "/" : date.includes(".") ? "." : null;
      if (separator && date.split(separator)[2]?.length === 4) {
        const [day, month, year] = date.split(separator);
        const adjustedYear = Number(year) < 2100 ? Number(year) : Number(year) - 543;
        processedDate = `${adjustedYear}-${("0" + month).slice(-2)}-${("0" + day).slice(-2)}`;
      }
    }
  }

  const new_date = new Date(processedDate);
  if (isNaN(new_date.getTime())) return "-";
  const day = new_date.getDate();
  const month = new_date.getMonth();
  const rawYear = new_date.getFullYear();
  const year = locale?.toLowerCase() === "en" 
    ? (rawYear > 2100 ? rawYear - 543 : rawYear)
    : (rawYear > 2100 ? rawYear : rawYear + 543);
  const hour = new_date.getHours();
  const minute = new_date.getMinutes();
  const second = new_date.getSeconds();
  if (!format) {
    return `${String(day).padStart(2, "0")}/${String(month + 1).padStart(2, "0")}/${String(year).padStart(4, "0")}`;
  }

  if (format === "date") {
    return new_date.getTime();
  }
  let formatted = format.toLowerCase()
    // Time formats
    .replace(/hh:mm:ss/g, `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}:${String(second).padStart(2, "0")}`)
    .replace(/hh:mm/g, `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`)
    .replace(/hh/g, String(hour).padStart(2, "0"))
    .replace(/h:m:s/g, `${hour}:${minute}:${second}`)
    .replace(/h:m/g, `${hour}:${minute}`)
    // Day formats
    .replace(/dd/g, String(day).padStart(2, "0"))
    .replace(/d/g, day)
    // Month formats
    .replace(/mmmm/g, array_full_month[month])
    .replace(/mmm/g, array_month[month])
    .replace(/mm/g, String(month + 1).padStart(2, "0"))
    .replace(/m/g, month + 1)
    // Year formats
    .replace(/yyyy/g, String(year).padStart(4, "0"))
    .replace(/yyy/g, year.toString().slice(-3))
    .replace(/yy/g, year.toString().slice(-2))
    .replace(/y/g, year);

  return formatted.includes('n') || formatted.includes('N') ? '' : formatted;
};
const GET = async (url, body) => {
  console.log("atob(tokens):",atob(tokens))
  return new Promise((resolve) => {
    let queryString = '';
    if (body) {
      queryString = '?' + Object.entries(body)
        .map(([key, value]) => `${key}=${value}`)
        .join('&');
    }
    const apiUrl = (process.env.REACT_APP_API_URL + url).replaceAll(' ', '') + queryString;

    fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'accept': 'application/json',
        'Authorization': atob(tokens)
      },
      cache: 'no-cache'
    })
      .then(result => result.json())
      .then(result => {
        if (result.status) {
          resolve(result);
          return;
        }
        const message = ERROR(result);
        if (message === 'ไม่พบโทเค็น') {
            localStorage.clear();
          alert('/', 'warning', 'แจ้งเตือน', message);
          resolve({ status: false, message });
            return;
          }
        if (message === 'fetch is not defined') {
          alert('', 'warning', 'แจ้งเตือน', 'ไม่พบข้อมูล');
          resolve({ status: false, message });
            return;
          }
        alert('', 'warning', 'แจ้งเตือน', message);
        resolve({ status: false, message });
      })
      .catch(() => {
        resolve({ status: false, message: 'Error' });
      });
  });
};
const POST = async (url, body) => {
  return new Promise((resolve) => {
    fetch((process.env.REACT_APP_API_URL + url).replaceAll(" ", ""), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: atob(tokens)
      },
      cache: "no-cache",
      body: JSON.stringify(body),
    })
      .then((result) => result.json())
      .then((result) => {
        if (result.status) {
          resolve(result);
          return;
        }
        const message = ERROR(result);
          if (message === "ไม่พบโทเค็น") {
            localStorage.clear();
            alert("/", "warning", "แจ้งเตือน", message);
          resolve({ status: false, message });
            return;
          }
          alert("", "warning", "แจ้งเตือน", message);
        resolve({ status: false, message });
      })
      .catch(() => {
        resolve({ status: false, message: "Error" });
      });
  });
};
const PUT = async (url, body) => {
  return new Promise((resolve) => {
    fetch((process.env.REACT_APP_API_URL + url).replaceAll(" ", ""), {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: atob(tokens)
      },
      cache: "no-cache",
      body: JSON.stringify(body),
    })
      .then((result) => result.json())
      .then((result) => {
        if (result.status) {
          resolve(result);
          return;
        }
        const message = ERROR(result);
          if (message === "ไม่พบโทเค็น") {
            localStorage.clear();
            alert("/", "warning", "แจ้งเตือน", message);
          resolve({ status: false, message });
            return;
          }
          alert("", "warning", "แจ้งเตือน", message);
        resolve({ status: false, message });
      })
      .catch(() => {
        resolve({ status: false, message: "Error" });
      });
  });
};
const DELETE = async (url, body) => {
  return new Promise((resolve) => {
    fetch((process.env.REACT_APP_API_URL + url).replaceAll(" ", ""), {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: atob(tokens)
      },
      cache: "no-cache",
    })
      .then((result) => result.json())
      .then((result) => {
        if (result.status) {
          resolve(result);
          return;
        }
        const message = ERROR(result);
          if (message === "ไม่พบโทเค็น") {
            localStorage.clear();
            alert("/", "warning", "แจ้งเตือน", message);
          resolve({ status: false, message });
            return;
          }
          alert("", "warning", "แจ้งเตือน", message);
        resolve({ status: false, message });
      })
      .catch(() => {
        resolve({ status: false, message: "Error" });
      });
  });
};
const ERROR = (result) => {
  if (!result) return '';
  if (result.detail) {
    return result.detail;
  }
  if (result.data) {
    if (result.data.message) {
      return result.data.message;
    }
    return result.data;
  }
  return result.message || '';
};
const random_charactor = (length) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  return Array.from({ length }, () => 
    characters.charAt(Math.floor(Math.random() * characters.length))
  ).join('');
};
const loading = (status) => {
  try {
    const loading = document.getElementById("loading");
    if (status === true) {
      loading.classList.remove("d-none");
    } else if (status === false) {
      loading.classList.add("d-none");
    }
  } catch (e) {}
};
const Status = (status, color) => {
  return (<span className={"bg-"+(color || "primary")+"-light text-"+(color || "primary")+" px-3 rounded-4 text-nowrap"}>{status}</span>);
}
const params = (name) => {
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get(name);
}

class DatePicker extends Component {
  state = {
    value: "",
    default: new Date(),
    array_date: [],
    array_month: ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"],
    array_year: [],
    showCalendar: false,
    min: new Date(new Date().setFullYear(new Date().getFullYear() - 100)),
    max: new Date(new Date().setFullYear(new Date().getFullYear() + 100)),
  };
  componentDidMount = () => {
    let year = [];
    for (let i = -100; i < 100; i++) {
      year.push(new Date().getFullYear() + i);
    }
    this.setState({ array_year: year });
    if (this.props.value) {
      this.setState({
        default: new Date(this.props.value),
        value: new Date(this.props.value),
      });
    }
    if (this.props.min) {
      this.setState({ min: new Date(this.props.min) });
    } else {
      this.setState({
        min: new Date(new Date().setFullYear(new Date().getFullYear() - 100)),
      });
    }
    if (this.props.max) {
      this.setState({ max: new Date(this.props.max) });
    } else {
      this.setState({
        max: new Date(new Date().setFullYear(new Date().getFullYear() + 100)),
      });
    }
    this.getDates();
  };
  componentWillReceiveProps = (props) => {
    if (props.min) {
      this.setState({ min: new Date(props.min) });
    } else {
      this.setState({
        min: new Date(new Date().setFullYear(new Date().getFullYear() - 100)),
      });
    }
    if (props.max) {
      this.setState({ max: new Date(props.max) });
    } else {
      this.setState({
        max: new Date(new Date().setFullYear(new Date().getFullYear() + 100)),
      });
    }
    if (props.value) {
      this.setState({
        default: new Date(props.value),
        value: new Date(props.value),
      });
    } else {
      this.setState({ default: new Date(), value: "" });
    }
  };
  onChangeDate = (option) => {
    if (option === "") {
      this.props.onChange("");
    } else {
      this.props.onChange(Number(option.getFullYear()) + "-" + ("0" + (Number(option.getMonth()) + 1)).slice(-2) + "-" + ("0" + option.getDate()).slice(-2));
    }
    this.setState({ value: option, showCalendar: false });
  };
  getDates = () => {
    let dates = [];
    let date = new Date(this.state.default.getFullYear(), this.state.default.getMonth(), 1);
    for (let d = 0; d < new Date(date).getDay(); d++) {
      dates.push("");
    }
    while (date.getMonth() === this.state.default.getMonth()) {
      dates.push(new Date(date).getDate());
      date.setDate(date.getDate() + 1);
    }
    this.setState({ array_date: dates });
  };
  render() {
    return (
      <div
        style={{
          position: "relative",
          width: "100%",
          fontSize: "0.8rem",
        }}
      >
        {this.state.showCalendar && (
          <div
            style={{
              bottom: 0,
              left: 0,
              top: 0,
              right: 0,
              backgroundColor: "#0000",
              zIndex: 1000,
              position: "fixed",
            }}
            onClick={() => {
              this.setState({ showCalendar: false });
            }}
          ></div>
        )}
        <div style={{ width: "100%" }}>
          <input
            className={this.props.className}
            style={{ cursor: "pointer" }}
            type="text"
            value={this.state.value && typeof this.state.value === "object" ? ("0" + this.state.value.getDate()).slice(-2) + "/" + ("0" + (Number(this.state.value.getMonth()) + 1)).slice(-2) + "/" + Number(this.state.value.getFullYear()) : this.state.value}
            placeholder={this.props.placeholder ? this.props.placeholder : "dd/mm/yyyy"}
            onFocus={() => {
              this.setState({
                showCalendar: true,
                default: this.state.value ? new Date(this.state.value) : new Date(),
              });
              setTimeout(() => {
                this.getDates();
                let offsets = document.getElementById("calendar");
                let box_left = offsets.getBoundingClientRect().left;
                let box_top = offsets.getBoundingClientRect().top;
                let width = window.innerWidth;
                let height = window.innerHeight;
                if (box_left + 300 > width) {
                  offsets.style.left = "-300px";
                }
                if (box_top + 335 > height) {
                  offsets.style.top = "-335px";
                }
                offsets.style.opacity = "1";
              }, 1);
            }}
            onChange={(e) => {
              this.setState({ value: e.target.value });
            }}
            onKeyUp={(e) => {
              if (e.key === "Enter") {
                e.target.blur();
              }
            }}
            onBlur={() => {
              const regex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
              if (regex.test(this.state.value)) {
                this.setState({ default: new Date(Number(this.state.value.split("/")[2]) > 2100 ? Number(this.state.value.split("/")[2]) - 543 : Number(this.state.value.split("/")[2]), Number(this.state.value.split("/")[1]) - 1, Number(this.state.value.split("/")[0])) });
                setTimeout(() => {
                  this.onChangeDate(new Date(this.state.default.getFullYear(), this.state.default.getMonth(), this.state.default.getDate()));
                }, 10);
              } else if (typeof this.state.value === "object" && this.state.value !== "Invalid Date") {
                console.log("Invalid Date");
              } else if (this.state.value.length === 8 && Number(this.state.value)) {
                this.setState({ default: new Date(Number(this.state.value.slice(-4)) > 2100 ? Number(this.state.value.slice(-4)) - 543 : Number(this.state.value.slice(-4)), Number(this.state.value.slice(2, 4)) - 1, Number(this.state.value.slice(0, 2))) });
                setTimeout(() => {
                  this.onChangeDate(new Date(this.state.default.getFullYear(), this.state.default.getMonth(), this.state.default.getDate()));
                }, 10);
              } else {
                this.setState({ value: "" });
              }
            }}
            disabled={this.props.disabled}
            maxLength={10}
          />
          {this.state.showCalendar && (
            <div
              id="calendar"
              style={{
                opacity: 0,
                zIndex: 1001,
                width: 300,
                position: "absolute",
                marginTop: "0.2rem",
                paddingTop: "0.3rem",
                paddingBottom: "0.3rem",
                display: "flex",
                flexDirection: "column",
                minWidth: 0,
                wordWrap: "break-word",
                backgroundColor: "#ffffff",
                backgroundClip: "border-box",
                border: "1px solid rgba(0,0,0,.125)",
                borderRadius: 8,
                boxShadow: "0 0.3rem 1rem rgba(0, 0, 0, .15)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {this.state.default.getMonth() === 0 && this.state.default.getFullYear() === new Date().getFullYear() - 100 ? (
                  <span style={{ color: "#e1e2e2", padding: "1rem" }}>{"<"}</span>
                ) : (
                  <span
                    style={{ cursor: "pointer", padding: "1rem" }}
                    onClick={() => {
                      let date = this.state.default;
                      date.setMonth(date.getMonth() - 1);
                      this.setState({ default: date });
                      setTimeout(() => {
                        this.getDates();
                      }, 1);
                    }}
                  >
                    {"<"}
                  </span>
                )}
                {/* เดือน */}
                <select
                  style={{ width: 100, borderWidth: 0, textAlign: "center" }}
                  onChange={(e) => {
                    let date = this.state.default;
                    date.setMonth(e.target.value);
                    this.setState({ default: date });
                    setTimeout(() => {
                      this.getDates();
                    }, 1);
                  }}
                  value={this.state.default ? this.state.default.getMonth() : " "}
                >
                  {this.state.array_month.map((item, index) => (
                    <option value={index}>{item}</option>
                  ))}
                </select>
                <label
                  style={{
                    marginLeft: "0.3rem",
                    marginRight: "0.3rem",
                    paddingBottom: 0,
                    cursor: "pointer",
                  }}
                >
                  {this.props.type === "th" ? "พ.ศ." : "ค.ศ."}
                </label>
                {/* ปี */}
                <select
                  style={{ width: 60, borderWidth: 0, textAlign: "center" }}
                  onChange={(e) => {
                    let date = this.state.default;
                    date.setFullYear(e.target.value);
                    this.setState({ default: date });
                    setTimeout(() => {
                      this.getDates();
                    }, 1);
                  }}
                  value={this.state.default ? this.state.default.getFullYear() : " "}
                >
                  {this.state.array_year.map((item, index) => (
                    <option value={item}>{this.props.type === "th" ? item + 543 : item} </option>
                  ))}
                </select>
                {this.state.default.getMonth() === 11 && this.state.default.getFullYear() === new Date().getFullYear() + 99 ? (
                  <span style={{ color: "#e1e2e2", padding: "1rem" }}>{">"}</span>
                ) : (
                  <span
                    style={{ cursor: "pointer", padding: "1rem" }}
                    onClick={() => {
                      let date = this.state.default;
                      date.setMonth(date.getMonth() + 1);
                      this.setState({ default: date });
                      setTimeout(() => {
                        this.getDates();
                      }, 1);
                    }}
                  >
                    {">"}
                  </span>
                )}
              </div>
              <div style={{ marginBottom: "1rem", marginLeft: 0, marginRight: 0, width: "100%", display: "flex", flexWrap: "wrap" }}>
                {["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."].map((item, index) => (
                  <div key={"day_" + index} style={{ width: "14.28%", padding: "0,25rem 0", textAlign: "center" }}>
                    {item}
                  </div>
                ))}
              </div>
              <div
                style={{
                  marginTop: "-1rem",
                  marginLeft: 0,
                  marginRight: 0,
                  width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                  height: 220,
                }}
              >
                {this.state.array_date.map((item, index) => (
                  <div
                    key={"date_" + index}
                    style={
                      this.state.value && typeof this.state.value === "object" && item && this.state.value.getDate() === item && this.state.value.getMonth() === this.state.default.getMonth() && this.state.value.getFullYear() === this.state.default.getFullYear()
                        ? new Date(this.state.default.getFullYear(), this.state.default.getMonth(), item) > this.state.min.getTime() && new Date(this.state.default.getFullYear(), this.state.default.getMonth(), item) < this.state.max.getTime()
                          ? {
                              width: "14.28%",
                              paddingTop: "0.3rem",
                              paddingBottom: "0.3rem",
                              textAlign: "center",
                              cursor: "pointer",
                              backgroundColor: "#0d6efd",
                              color: "#ffffff",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }
                          : {
                              width: "14.28%",
                              paddingTop: "0.3rem",
                              paddingBottom: "0.3rem",
                              textAlign: "center",
                              backgroundColor: "#0d6efd",
                              color: "#e1e2e2",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }
                        : new Date(this.state.default.getFullYear(), this.state.default.getMonth(), item) > this.state.min.getTime() && new Date(this.state.default.getFullYear(), this.state.default.getMonth(), item) < this.state.max.getTime()
                        ? {
                            width: "14.28%",
                            paddingTop: "0.3rem",
                            paddingBottom: "0.3rem",
                            textAlign: "center",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }
                        : {
                            width: "14.28%",
                            paddingTop: "0.3rem",
                            paddingBottom: "0.3rem",
                            textAlign: "center",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#e1e2e2",
                          }
                    }
                    onClick={() => {
                      if (new Date(this.state.default.getFullYear(), this.state.default.getMonth(), item) > this.state.min.getTime() && new Date(this.state.default.getFullYear(), this.state.default.getMonth(), item) < this.state.max.getTime()) {
                        this.onChangeDate(new Date(this.state.default.getFullYear(), this.state.default.getMonth(), item));
                      }
                    }}
                  >
                    {item}
                  </div>
                ))}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  paddingLeft: "0.3rem",
                  paddingRight: "0.3rem",
                }}
              >
                {this.props.clearable !== false ? (
                  <label
                    style={{ cursor: "pointer", color: "#0d6efd" }}
                    onClick={() => {
                      this.onChangeDate("");
                    }}
                  >
                    clear
                  </label>
                ) : (
                  <label></label>
                )}
                <label
                  style={{ cursor: "pointer", color: "#0d6efd" }}
                  onClick={() => {
                    this.onChangeDate(new Date());
                  }}
                >
                  To day
                </label>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
class Select extends Component {
  state = {
    showSelectOption: false,
    search: "",
    selected: "",
  };
  componentDidMount = () => {
  };
  componentWillReceiveProps = (props) => {
  };
  render() {
    return (
      
      <div style={{ position: "relative",padding:0 }} className={this.props.className}>
        {this.state.showSelectOption && (
          <div style={{bottom: 0, left: 0, top: 0, right: 0, backgroundColor: "#0000", zIndex: 1000, position: "fixed"}} onClick={() => { this.setState({ showSelectOption: false }) }}></div>
        )}
        <div style={{position:"relative"}}>
        <input
            className={this.props.className.replaceAll("mb-2","").replaceAll("mb-3","").replaceAll("mb-4","").replaceAll("mb-5","")}
            style={{width:"100%", backgroundColor: this.props.disabled ? "#e9ecef" : "#00000000", border: 0}}
            type="text"
            value={!this.state.search && !this.state.showSelectOption && this.props.value ? this.props.options.find(e=>e.value === this.props.value)?.label : this.state.search}
            placeholder={this.props.placeholder || ""}
            onFocus={() => {
              this.setState({ showSelectOption: true, search: "", selected: "" });
            }}
            onChange={(e)=>{this.setState({search:e.target.value})}}
            disabled={this.props.disabled}
          />
          <div style={{display: "flex", position: "absolute", right: 8, top: "50%"}}>
          <div style={{width: 10, height: 2, backgroundColor: "#c2c2c2", transform: "rotate(45deg)"}}></div>
          <div style={{width: 10, height: 2, backgroundColor: "#c2c2c2", transform: "rotate(315deg)", marginLeft: -4}}></div>
          </div>
          </div>
          {this.state.showSelectOption && (
            <div style={{minWidth: 150, width: "100%", padding: 6, borderRadius: 6, borderWidth: 1, borderColor: "#d2d2d2", borderStyle: "solid", backgroundColor: "#fdfdfd", position: "absolute", top: 40, zIndex: 1001}}>
              <div style={{maxHeight:400,overflow:"scroll",scrollbarWidth: "none", msOverflowStyle: "none"}}>
              {(this.props.options.filter(e=>!this.state.search || e.label.includes(this.state.search)).length !== 0) && this.props.default !== false && (
              <div 
                  style={{width: "100%", cursor: "pointer", padding: 4, backgroundColor: this.state.selected === "" ? "#dfdfdf" : "#fff0"}}
                  onClick={()=>{
                    this.setState({ showSelectOption: false, search: "", selected: "" });
                    this.props.onChange("", {value: "", label: ""})}}
                  onMouseEnter={() => this.setState({ selected: "" })}
                    >-- กรุณาเลือก --</div>
                  )}
                {this.props.options.filter(e=>!this.state.search || e.label.includes(this.state.search)).map((item,index)=>(
                  <div 
                  key={index}
                  style={{display: "flex", width: "100%", cursor: "pointer", padding: 4, backgroundColor: this.state.selected === item.value ? "#dfdfdf" : "#fff0"}} 
                  onClick={()=>{
                    this.setState({ showSelectOption: false, search: "", selected: "" });
                    this.props.onChange(item.value, item)}}
                  onMouseEnter={() => this.setState({ selected: item.value })}
                    >{item.front || ""}{item.label}</div>
                ))}
                <div style={{maxHeight: 300, overflow: "scroll"}}>
                {this.props.options.filter(e=>!this.state.search || e.label.includes(this.state.search)).length === 0 && (
                  <div style={{width: "100%", textAlign: "center", color: "#2c2c2c"}}>ไม่พบข้อมูล...</div>
                )}
                </div>
              </div>
            </div>
          )}
      </div>
    );
  }
}
class BtnIcon extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div>
       {this.props.type === "print" && (<div className="status bg-primary-light wpx-25 hpx-25 icon px-1 pointer text-primary" title="พิมพ์เอกสาร" onClick={() => {this.props.onClick()}}>{"\uf02f"}</div>)}
       {this.props.type === "view" && (<div className="status bg-success-light wpx-25 hpx-25 icon px-1 pointer text-success" title="ดูรายละเอียด" onClick={() => {this.props.onClick()}}>{"\uf06e"}</div>)}
       {this.props.type === "download" && (<div className="status bg-info-light wpx-25 hpx-25 icon px-1 pointer text-info" title="ดาวน์โหลดเอกสาร" onClick={() => {this.props.onClick()}}>{"\uf019"}</div>)}
       {this.props.type === "email" && (<div className="status bg-secondary-light wpx-25 hpx-25 icon px-1 pointer text-secondary" title="ส่งเอกสารทางอีเมล" onClick={() => {this.props.onClick()}}>{"\uf0e0"}</div>)}
       {this.props.type === "update" && (<div className="status bg-warning-light wpx-25 hpx-25 icon px-1 pointer text-orange" title="แก้ไขข้อมูล" onClick={() => {this.props.onClick()}}>{"\uf044"}</div>)}
       {this.props.type === "approve" && (<div className="status bg-purple-light wpx-25 hpx-25 icon px-1 pointer text-purple" title="เปลี่ยนแปลงสถานะ" onClick={() => {this.props.onClick()}}>{"\uf00c"}</div>)}
       {this.props.type === "delete" && (<div className="status bg-danger-light wpx-25 hpx-25 icon px-1 pointer text-danger" title="ลบข้อมูล" onClick={() => {this.props.onClick()}}>{"\uf1f8"}</div>)} 
      </div>
     );
  }
}

export {profile, tokens, alert, total, float, toFixed, format_date, random_charactor, GET, POST, PUT, DELETE, loading, Status, params, required, DatePicker, Select, BtnIcon};
export { default as Swal } from "sweetalert2";
export { default as Pagination } from "@mui/material/Pagination";
export { default as Switch } from "react-switch";
export { default as Navbar } from "../components/Navbar.js";
export { Modal } from "react-bootstrap";
export { default as Resizer } from "react-image-file-resizer";


